import axios from "axios";

export default function exportTransactionReport({ format }) {
  return axios.get(
    `/campaignV2/transactionReport/ExportReports?format=${format}`,
    { responseType: "blob" }
  );
}
